/**
 * ตารางเวรทีมงาน (หัวหน้างาน) — ใช้ปฏิทินตัวเดียวกับฝั่ง HR.
 *
 * "ดู" กับ "จัด" คนละขอบเขตกันโดยตั้งใจ: หัวหน้างานดูตารางได้ทุกคนทุกแผนก
 * (ต้องรู้ว่าแผนกอื่นลงเวรใครไว้ ถึงจะวางกะทีมตัวเองไม่ชนกัน) แต่การ "แก้เวร"
 * ยังจำกัดลูกทีมสายตัวเองที่ /hr/shift/roster เหมือนเดิม.
 */
import { AdminLayout } from '../components/layout/AdminLayout';
import { HRRosterCalendarContent } from './hr/RosterCalendar';

export function TeamSchedule() {
  return (
    <AdminLayout title="ตารางเวรทีมงาน" subtitle="ดูตารางเวรได้ทุกแผนก · แก้เวรได้เฉพาะลูกทีมในสายงานของคุณ">
      <HRRosterCalendarContent />
    </AdminLayout>
  );
}
